var _module = require('../../components/module.js');
var config = require('config');
var _ = require('lodash');

_module.service('$firstam', [
    '$log',
    '$http',

    function firstam($log, $http) {
        return {
            getPhotos: function getPhotos(listingId) {
                return $http.get('/v1/faphotos/' + listingId)
                    .then(function (data) {
                        return data.data.data;
                    }).catch(function (err) {
                        $log.error('Error fetching first am photos', err);
                        return [];
                    });
            }
        };
    }
]);
